import { createFileRoute, Outlet } from '@tanstack/react-router';

import { Page } from './-components/Page';

export const Route = createFileRoute('/_admin')({
	component: function Claims() {
		return (
			<Page size="xl">
				<Outlet />
			</Page>
		);
	},
});
